// src/pages/admin/Stores.js
import React from "react";
import AdminStores from "../../components/Admin/AdminStores";

export default function AdminStoresPage() {
  return <AdminStores />;
}
